import { Artwork_Bool_Exp } from 'common/schema/commonSchemaRemoteTypes';
import {
  AppliedListingModifier,
  ARTWORK_QUERY_CONDITION_IN,
  FILTERS_DEFAULT_VALUE,
  isOptionType,
  ListingModifier,
  ListingModifierOption,
} from './types';

export type PrizesOptionType = {
  id: number;
  name: string;
  title: string;
};

export const generatePrizesFilterOption = ({ id, name }: PrizesOptionType): ListingModifierOption => ({
  name,
  value: id,
  key: 'ARTWORK_QUERY_CONDITION_IN',
  payload: { art_prizes: { art_prize_show_id: { _in: [id] } } },
});

export const getPrizesFilter = (): ListingModifier => ({
  type: 'PRIZES',
  allOptions: [
    {
      value: FILTERS_DEFAULT_VALUE,
      name: 'filterStrings.prize.all',
      key: 'ARTWORK_QUERY_CONDITION_IN',
      payload: {},
    },
  ],
});

export const getAppliedPrizesFilter = (
  prizesOptions: PrizesOptionType[]
): AppliedListingModifier<ARTWORK_QUERY_CONDITION_IN> => {
  const prizesFilter = getPrizesFilter();
  const newPrizesFilterOptions = prizesOptions.map(generatePrizesFilterOption);
  prizesFilter.allOptions.push(...newPrizesFilterOptions);
  return {
    ...prizesFilter,
    selectionType: 'MULTIPLE',
    selectedOptions: [FILTERS_DEFAULT_VALUE],
    flattenSelectedOptions: (options, selectedOptions) => {
      const selectedModifiers = options.filter((option) => selectedOptions.includes(option.value));
      const flattenedModifiers = selectedModifiers.reduce<Artwork_Bool_Exp>((flattenedOptions, currentOption) => {
        if (
          isOptionType<ARTWORK_QUERY_CONDITION_IN>(currentOption, 'ARTWORK_QUERY_CONDITION_IN') &&
          currentOption.payload.art_prizes?.art_prize_show_id?._in
        ) {
          return {
            art_prizes: {
              art_prize_show_id: {
                _in: [
                  ...(flattenedOptions.art_prizes?.art_prize_show_id?._in ?? []),
                  ...currentOption.payload.art_prizes?.art_prize_show_id?._in,
                ],
              },
            },
          };
        }
        return flattenedOptions;
      }, {});

      return {
        key: 'ARTWORK_QUERY_CONDITION_IN',
        name: 'APPLIED_PRIZES_FILTER',
        value: -1,
        payload: flattenedModifiers,
      };
    },
  };
};
